import React, { forwardRef, ButtonHTMLAttributes } from 'react';
import styles from './IconButton.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'solid' | 'outline';
  colour?: 'blueberry' | 'kale' | 'grape' | 'curry' | 'salt' | 'squid-ink' | 'liquorice';
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ variant = 'outline', colour = 'blueberry', children, disabled, ...props }, ref) => {
    return (
      <button
        className={cx('button', { ['disabled']: disabled, [`${colour}-${variant}`]: true })}
        disabled={disabled}
        type="button"
        role="button"
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  },
);

IconButton.displayName = 'IconButton';

export default IconButton;
